/*
 * Our Story — GSAP reveals + staggers, triggered by IntersectionObserver.
 */
(function () {
	'use strict';

	var gsap = window.gsap;
	var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	// If we can't / shouldn't animate, release the anti-FOUC pre-hide so content shows.
	if (!gsap || !('IntersectionObserver' in window) || reduced) {
		document.documentElement.classList.remove('os-anim');
		return;
	}

	var $ = function (s, sc) { return (sc || document).querySelector(s); };
	var $$ = function (s, sc) { return Array.prototype.slice.call((sc || document).querySelectorAll(s)); };

	// One observer runs each element's reveal once, the moment it enters view.
	// A trigger can carry several jobs (e.g. a section that reveals both its
	// caption and its thumbnail strip), so callbacks are stored in a list.
	var jobs = new WeakMap();
	var io = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			var runs = jobs.get(entry.target);
			io.unobserve(entry.target);
			jobs['delete'](entry.target);
			if (runs) runs.forEach(function (run) { run(); });
		});
	}, { rootMargin: '0px 0px -15% 0px', threshold: 0 });

	function onEnter(el, run) {
		if (!el) return;
		var runs = jobs.get(el);
		if (runs) { runs.push(run); return; }
		jobs.set(el, [run]);
		io.observe(el);
	}

	// Content — fade + rise, staggered.
	function reveal(trigger, items, opts) {
		opts = opts || {};
		if (!trigger || !items || !items.length) return;
		gsap.set(items, { autoAlpha: 0, y: 28 });
		onEnter(trigger, function () {
			gsap.to(items, { autoAlpha: 1, y: 0, duration: 0.85, stagger: opts.stagger || 0.09, ease: 'power2.out' });
		});
	}

	// Image — gentle scale-in.
	function revealImage(el) {
		if (!el) return;
		gsap.set(el, { autoAlpha: 0, scale: 0.92 });
		onEnter(el, function () {
			gsap.to(el, { autoAlpha: 1, scale: 1, duration: 0.7, ease: 'power2.out' });
		});
	}

	// Fade only — safe for elements that carry their own CSS transform.
	function fadeIn(el, opts) {
		opts = opts || {};
		if (!el) return;
		gsap.set(el, { autoAlpha: 0 });
		onEnter(opts.trigger || el, function () {
			gsap.to(el, { autoAlpha: 1, duration: 0.9, delay: opts.delay || 0, ease: 'power1.out' });
		});
	}

	// 1. HERO — photo and the curved title badge come in together (one entrance).
	var hero = $('.os-hero');
	if (hero) {
		var heroImg = $('.os-hero__img', hero);
		var heroBadge = $('.os-hero__badge', hero); // has translateX(-50%) → fade only
		var tl = gsap.timeline();
		if (heroImg) tl.fromTo(heroImg,
			{ autoAlpha: 0, scale: 1.06 },
			{ autoAlpha: 1, scale: 1, duration: 1.5, ease: 'power3.out' }, 0.1);
		if (heroBadge) tl.fromTo(heroBadge,
			{ autoAlpha: 0 },
			{ autoAlpha: 1, duration: 1.1, ease: 'power2.out' }, 0.3);
	}

	// 2. INTRO — narrative reveal (staggered) + side photos scale in.
	var intro = $('.os-intro');
	if (intro) {
		var introText = $('.os-intro__text', intro);
		if (introText) reveal(introText, $$('.os-intro__body p', introText), { stagger: 0.12 });
		$$('.os-intro__media', intro).forEach(function (m) { revealImage(m); });
	}

	// 3. PULLQUOTES — fade + rise as each band enters.
	$$('.os-pullquote').forEach(function (band) {
		var text = $('.os-pullquote__text', band);
		if (text) reveal(band, [text]);
	});

	// 4. STORY SECTIONS — staggered text reveal + framed image scale-in.
	//    Bringing section also fades in its caption + thumbnail strip (fade only,
	//    so the Swiper layout and the drag handle are never transformed).
	$$('.os-story').forEach(function (section) {
		var text = $('.os-story__text', section);
		if (text) reveal(text, $$('.os-story__eyebrow, .os-story__body p, .os-story__signature', text));
		revealImage($('.os-story__frame', section));
		[$('.os-ba__caption', section), $('.os-ba__thumbs', section)].forEach(function (el, i) {
			if (el) fadeIn(el, { trigger: section, delay: 0.15 + i * 0.12 });
		});
	});
})();
